import { Action } from '@ngrx/store';

export const TRY_SIGNIN = 'TRY_SIGNIN';
export const TRY_SIGNUP = 'TRY_SIGNUP';
export const SIGNIN = 'SIGNIN';
export const SIGNUP = 'SIGNUP';
export const SET_TOKEN = 'SET_TOKEN';
export const LOGOUT = 'LOGOUT';
export const TRY_SINGIN_BY_UID = 'TRY_SIGNIN_BY_UID';
export const TRY_SIGNUP_BY_GOOGLE = 'TRY_SIGNUP_BY_GOOGLE';
export const TRY_SIGNUP_BY_FACEBOOK = 'TRY_SIGNUP_BY_FACEBOOK';

export class TrySignin implements Action {
  readonly type = TRY_SIGNIN;

  constructor(
    public payload: {email: string, password: string}
  ) {}
}

export class TrySignup implements Action {
  readonly type = TRY_SIGNUP;

  constructor(
    public payload: {email: string, password: string}
  ) {}
}

export class Singin implements Action {
  readonly type = SIGNIN;
}

export class TrySinginByUid implements Action {
  readonly type = TRY_SINGIN_BY_UID;

  constructor(public payload: {userUid: string, withRedirect: boolean}) {
  }

}

export class TrySingupByFacebook implements Action {
  readonly type = TRY_SIGNUP_BY_FACEBOOK;

  constructor(public payload: {accessToken: string, params: any}) {
  }

}

export class TrySingupByGoogle implements Action {
  readonly type = TRY_SIGNUP_BY_GOOGLE;

  constructor(public payload: {accessToken: string, params: any}) {
  }

}

export class Signup implements Action {
  readonly type = SIGNUP;
}

export class SetToken implements Action {
  readonly type = SET_TOKEN;

  constructor(
    public payload: {token: string, exp: number, id: number}
  ) {}
}

export class Logout implements Action {
  readonly type = LOGOUT;
}

export type AuthActions = TrySignin | TrySignup | Singin | Signup | SetToken | Logout | TrySinginByUid
  | TrySingupByFacebook | TrySingupByGoogle;
